import React from 'react';

import DesktopPanelLayout from './DesktopPanelLayout';
import MobilePanelLayout from './MobilePanelLayout';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';

function PanelLayout({
  leftPanelChildren,
  leftPanelDisabled,
  middlePanelChildren,
  middlePanelFormFooter,
  rightPanelChildren,
  rightPanelDisabled,
  panelsProps = {},
  invertPanels = false,
}) {
  const { isMobileDevice } = useWindowDimensions();

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {isMobileDevice ? (
        <MobilePanelLayout
          leftPanelDisabled={leftPanelDisabled}
          middlePanelChildren={middlePanelChildren}
          middlePanelFormFooter={middlePanelFormFooter}
          rightPanelChildren={rightPanelChildren}
          rightPanelDisabled={rightPanelDisabled}
          panelsProps={panelsProps}
        />
      ) : (
        <DesktopPanelLayout
          leftPanelChildren={leftPanelChildren}
          leftPanelDisabled={leftPanelDisabled}
          middlePanelChildren={middlePanelChildren}
          middlePanelFormFooter={middlePanelFormFooter}
          rightPanelChildren={rightPanelChildren}
          rightPanelDisabled={rightPanelDisabled}
          panelsProps={panelsProps}
          invertPanels={invertPanels}
        />
      )}
    </div>
  );
}

export default PanelLayout;
